import type { ReactNode } from 'react';
import styles from './styles.module.css';

interface PageHeroProps {
  children: ReactNode;
  /** Inner container max width in px. Defaults to 1000. */
  maxWidth?: number;
  /** Extra bottom padding for taller heroes. */
  pad?: string;
  className?: string;
}

export function PageHero({ children, pad = '46px 0px 58px 0px', className = '' }: PageHeroProps) {
  return (
    <section className={`${styles.hero} ${className}`}>
      <div className={`${styles.blob} ${styles.blobOrange}`} />
      <div className={`${styles.blob} ${styles.blobBlue}`} />
      <div className={styles.grid} />
      <div className={`${styles.inner} container`}>{children}</div>
    </section>
  );
}
